<template>
  <CoreExpand
    :title="fixflowHeading"
  >
    <iframe
      scrollbars="no"
      style="border:0px;width:100%;height:700px;overflow:hidden"
      src="https://claydonhomes.fixflo.com/issue/plugin"
    />
  </CoreExpand>
</template>

<script>
export default {
  name: 'TenantAreaFixFlow',

  props: {
    fixflowHeading: {
      type: String,
      default: '',
    },
  },
};
</script>
